import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function MessageSelectionsPage() {
  return (
    <SectionLayout title="Selections">
      {/* Message selections content will go here */}
    </SectionLayout>
  );
} 